export const RECENT_COMMITS_LIMIT_MIN = 1;
export const RECENT_COMMITS_LIMIT_MAX = 50;
export const RECENT_COMMITS_LIMIT_DEFAULT = 2;

export function sanitizeRecentCommitsLimit(value: unknown): number {
  const n =
    typeof value === 'number'
      ? value
      : typeof value === 'string'
        ? Number.parseInt(value.trim(), 10)
        : Number.NaN;
  if (!Number.isFinite(n)) return RECENT_COMMITS_LIMIT_DEFAULT;
  return Math.min(RECENT_COMMITS_LIMIT_MAX, Math.max(RECENT_COMMITS_LIMIT_MIN, Math.trunc(n)));
}
